import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpHeaders } from '@angular/common/http';
import { map,catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs'; 

@Injectable({
  providedIn: 'root'
})

export class AppService {

  // ServerUrl = 'http://imgglobal.in/propira/api/';
  ServerUrl = 'https://project.imgglobal.in/finaldemo/admin/Api2';
  //ServerUrl = 'https://localvocalonline.com/finaldemo/admin/Api2';
  errorData: {};
 
  httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  };

  constructor(private http:HttpClient) { }

  redirectUrl: string;

  isLoggedIn() {
    if (localStorage.getItem('currentUser')) {
      return true;
    }
    return false;
  }

  getAuthorizationToken() {

    if(this.isLoggedIn()){
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return currentUser.auth_token;
    }
    else{
      return '0';
    }
  }

  logout() {
    localStorage.removeItem('currentUser');
  }

  post(url, data){
    return  this.http.post<any>(this.ServerUrl+url,data,this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  postWithLogin(url, data){
    return  this.http.post<any>(this.ServerUrl+url,data,this.httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
   
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {

      // The backend returned an unsuccessful response code.

      // The response body may contain clues as to what went wrong.

      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }

    // return an observable with a user-facing error message

    this.errorData = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.'
    };

    return throwError(this.errorData);
  }
}
